export default __webpack_public_path__ + "static/media/tag-2.3eb28ee1.svg";